import React, { useState } from 'react';
import fileDownload from 'js-file-download';
import axiosInstance from '../../utils/axios';
import amplifyConfig from '../../config';
import API_PATH from '../../api/endpoints';
import type { AxiosResponse, AxiosError } from 'axios';
import type { S3ErrorResponse } from '../../types/common';

const useFileDownload = () => {
  const [isDownloading, seIsDownloading] = useState<boolean>(false);
  const [message, setMessage] = useState<string | undefined>(undefined);

  const download = async (path: string, fineName: string) => {
    setMessage('');
    seIsDownloading(true);

    try {
      // blobでファイルを受け取ってダウンロードする
      const { data } = await axiosInstance.get<undefined, AxiosResponse<Blob>>(amplifyConfig.apiGateway.URL + API_PATH.DOWNLOAD.S3, { responseType: 'blob', params: { filename: path } });
      // console.log(data);
      fileDownload(data, fineName);
      seIsDownloading(false);
    } catch (err) {
      // console.log(err);
      if (err.isAxiosError) {
        // err: AxiosError
        // リクエストを出した後にエラーが起きた場合
        if (err.response) {
          // ③サーバからエラーが返された場合
          // ========================================
          // レスポンスをblobとして受け取っているのでテキスト抽出してパースする
          const errorResponseString: string = await err.response.data.text();
          const errorResponse: AxiosError<Blob> | S3ErrorResponse = JSON.parse(errorResponseString);
          // console.log(errorResponse);
          if ((errorResponse as S3ErrorResponse).error !== undefined) {
            setMessage((errorResponse as S3ErrorResponse).error.message);
          } else {
            setMessage((errorResponse as AxiosError<Blob>).message);
          }
        } else {
          // ②リクエストがサーバに届く前にエラーが起きた場合
          // ========================================
          setMessage(err.message);
        }
      } else {
        // err: Error
        // ③リクエストを出す前にエラーが起きた場合
        // ========================================
        setMessage(err.message);
      }
      seIsDownloading(false);
    }
  };

  return { isDownloading, message, download };
};

export default useFileDownload;
